import React, { useEffect, useState } from 'react'
import { Lexicon } from '@nitidbit/lexicon'
import FinderDisclaimer from '../ClinicFinder/FinderDisclaimer/FinderDisclaimer.jsx'
import { updateSearchParams } from '../search/updateSearchParams.js'
import BCSuppliersResults from './BCSuppliersResults.jsx'
import BCSuppliersForm from './BCSuppliersForm.jsx'
import './BCSuppliers.scss'
import lexiconRaw from './BCSuppliersStrings.json'

const locale = document.documentElement.lang || 'en'
const lexicon = new Lexicon(
  lexiconRaw,
  locale,
  'bedsider/app/javascript/components/search/BCSuppliers/BCSuppliersStrings.json'
)
const suppliersLexicon = lexicon.subset('BCSupplier')
const initialURLParams = new URLSearchParams(window.location.search)

const SEARCH_API_URL = '/api/bc_suppliers'
const performSearchOnPageLoad = Array.from(initialURLParams.keys()).length > 0

const BLANK_NAVIGATE_RESPONSE = { suppliers: [], status: 0 }

const BCSuppliers = () => {
  const [location, setLocation] = useState(
    initialURLParams.get('location') || ''
  )
  const [navigateResponse, setNavigateResponse] = useState(
    BLANK_NAVIGATE_RESPONSE
  )
  const [hasPerformedSearch, setHasPerformedSearch] = useState(
    performSearchOnPageLoad
  )

  const fetchSuppliers = (searchParams) => {
    const paramsString = searchParams.toString()
    fetch(`${SEARCH_API_URL}?${paramsString}`)
      .then((response) => {
        if (response.status === 200) return response.json()
        throw response.status
      })
      .then((jsonArray) =>
        setNavigateResponse({ suppliers: jsonArray, status: 200 })
      )
      .catch((error) => setNavigateResponse({ suppliers: [], status: error }))
  }

  const onSearch = () => {
    const newParams = { location }

    const searchParams = updateSearchParams(newParams, false)
    fetchSuppliers(searchParams)
    setHasPerformedSearch(true)
    setNavigateResponse(BLANK_NAVIGATE_RESPONSE)
  }

  useEffect(() => {
    if (performSearchOnPageLoad) {
      onSearch()
    }
  }, [])

  return (
    <div className="BCSuppliers">
      {!hasPerformedSearch ? (
        <div className="search-container">
          <BCSuppliersForm
            lexicon={suppliersLexicon}
            location={location}
            setLocation={setLocation}
            onSearch={onSearch}
          />
        </div>
      ) : (
        <BCSuppliersResults
          location={location}
          setLocation={setLocation}
          onSearch={onSearch}
          navigateResponse={navigateResponse}
          lexicon={suppliersLexicon}
        />
      )}

      <FinderDisclaimer disclaimerText={suppliersLexicon.get('disclaimer')} />
    </div>
  )
}

export default BCSuppliers
